import React from 'react';
import {iconName} from '@packages/systems/wfdl-Qualified';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {wfdlType} from '@packages/systems/wfdl-parser';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';
const basicPlugin = Plugins.name('Basic');

const Span = Atom.createRender(
  ({attributes, classes, generateAttributes, data, innerHTML, renderChild}) => {
    return (
      <span {...generateAttributes(attributes, classes)}>
        {/* @ts-expect-error - TS2322 - innerHTML union includes non-ReactNode array types (TODO platform: fix innerHTML type issues) */}
        {innerHTML || getChildren(data).map((child) => renderChild(child))}
      </span>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Text Span',
  icon: {type: 'Component', value: [basicPlugin, iconName('Text')]},
  showEmpty: false,
  render: Span,
  fields: {children: wfdlType`List<Element>`},
});

export default config;
